import { create } from "zustand";

export const useVideoStreamStore = create((set) => ({
  stream: null,
  updateStream: (stream) => set({ stream }),
  clearStream: () =>
    set((state) => {
      if (state.stream) {
        state.stream.getTracks().forEach((track) => track.stop());
      }
      return { stream: null };
    }),
}));
